import Menu from './menu';
import Modal from './modal';
import Sorter from './sorter';
import OtherDate from './other_date';
import Watchlist from './watchlist';
import SavedSearches from './saved_searches';
import RemoveWatch from './remove_watch';
import Start from './start';
import PriceSearch from './price_search';
import $ from 'jquery';
import jQuery from 'jquery';
//
//
function bindFunctions() {
  jQuery.fn.reverse = [].reverse;
}

function init() {
  bindFunctions();

  Menu.init();
  Modal.init();
  Sorter.init();
  OtherDate.bind();
  Watchlist.bind();
  SavedSearches.bind();
  RemoveWatch.bind();

  Start.init();
  PriceSearch.init();
}

export default init;



// WEBPACK FOOTER //
// ./app/webroot/javascript/modules/init.js